'use strict';

// https://stackoverflow.com/questions/33656867/#answer-33658596
export const replaceNullsWithAverage = arr => {
  const clonedArray = arr.map(props => ({ ...props }));
  let ind = -1;
  let prevIndex;
  let nJumps;
  let valJump;

  for (let currIndex = 0; currIndex < clonedArray.length; currIndex++) {
    if (clonedArray[currIndex].value == null) {
      continue;
    } else if (prevIndex === undefined || (nJumps = (currIndex - prevIndex)) === 1) {
      prevIndex = currIndex;
      continue;
    }

    valJump = ((clonedArray[currIndex].value - clonedArray[prevIndex].value) / nJumps);

    ind = (+prevIndex);
    while (++ind < (+currIndex)) {
      clonedArray[ind].value = (clonedArray[ind - 1].value) + valJump;
    }
    prevIndex = currIndex;
  }

  return clonedArray;
};

export const removeNullValuesFromBeginningAndEnd = data => {
  let startIndex;
  for (let i = 0; i < data.length; i++) {
    const { value } = data[i];
    if (value !== null) {
      startIndex = i;
      break;
    }
  }

  let endIndex;
  for (let i = data.length - 1; i >= 0; i--) {
    const { value } = data[i];
    if (value !== null) {
      endIndex = i;
      break;
    }
  }
  return data.slice(startIndex, endIndex + 1);
};
